var React = require('react');
var Modal = require('react-bootstrap').Modal;
var Button = require('react-bootstrap').Button;
var ButtonLink = require('react-router-bootstrap').ButtonLink;
var Access = require('./Access');
var cx = require('classnames');

var Loading = require('../Loading');
var ServiceActions = require('../../actions/ServiceActions');
var ClientServiceStore = require('../../stores/ClientServiceStore');
var ClientStore = require('../../stores/ClientStore');
var ContactStore = require('../../stores/ContactStore');
var UserStore = require('../../stores/UserStore');
var AccessSelector = require('./AccessSelector');
var Invocation = require('../../api/Invocation');

function getState(props) {
  return {
    client: ClientStore.get(),
    loading: ContactStore.loading() || ClientStore.loading(),
    working: ContactStore._working,
  }
}

var AccessNew = React.createClass({
  contextTypes: {
    router: React.PropTypes.func
  },
  componentDidMount: function() {
    ClientStore.addChangeListener(this.update);
    ContactStore.addChangeListener(this.update);
    UserStore.addChangeListener(this.update);
  },
  componentWillMount: function () {
    this.update()

    var user = UserStore.getUser();

    if (user && !ClientServiceStore.has() && !ClientServiceStore.loading()) {
      ServiceActions.getServices(user);
    }
  },
  componentWillUnmount: function () {
    ClientStore.removeChangeListener(this.update);
    ContactStore.removeChangeListener(this.update);
    UserStore.removeChangeListener(this.update);
  },
  submit: function (e) {
    e.preventDefault()

    this.setState({ errors: null })

    Invocation.auth
      .auth(
        this.state.client.id,
        this.refs.email.getDOMNode().value,
        this.refs.roleSelector.getRoles(),
        this.refs.firstName.getDOMNode().value,
        this.refs.lastName.getDOMNode().value,
        this.refs.contactNumber.getDOMNode().value
      )
      .then(r => {
        if (r && r.res && r.res.status === 400) {
          // We've got errors.
          this.setState({ errors: r.res.body.violations })

          return
        }

        this.context.router.transitionTo('access')
      })
  },
  update: function () {
    this.setState(getState(this.props))
  },
  getInitialState: function () {
    return {
      errors: null,
      working: null,
    }
  },
  render: function () {
    let firstNameError
    let lastNameError
    let emailError
    let contactNumberError
    let roleError

    if (this.state.errors) {
      firstNameError = this.state.errors.find(e => e.property_path === "firstName")
      lastNameError = this.state.errors.find(e => e.property_path === "lastName")
      emailError = this.state.errors.find(e => e.property_path === "username")
      contactNumberError = this.state.errors.find(e => e.property_path === "contactNumber")
      roleError = this.state.errors.find(e => e.property_path === "roles")
    }

    return (
      <div>
        <Access />

        <Modal
          animation={false}
          onHide={() => this.context.router.transitionTo('access')}
          show
        >
          <form onSubmit={this.submit}>
            <div className="modal-header">
              <h4>Authorise Individual for {this.state.client ? this.state.client.name : <Loading />}</h4>
            </div>
            <div className="modal-body">
              <p className="text-orange">
                Please note that the user you are adding is required to perform
                additional actions to complete their registration before they will be
                authorised on behalf of <strong>{this.state.client ? this.state.client.name : <Loading />}</strong>.
              </p>

              <div className={cx('form-group', {
                'has-error': !!firstNameError
              })}>
                <label className="control-label required" htmlFor="firstName">First Name</label>
                <div>
                  <input
                    id="firstName"
                    type="text"
                    ref="firstName"
                    className="form-control"
                    required
                  />
                </div>
                {!!firstNameError && (<div className="help-block">{firstNameError.message}</div>)}
                <div className="help-block">Enter the individual's first name.</div>
              </div>

              <div className={cx('form-group', {
                'has-error': !!lastNameError
              })}>
                <label className="control-label required" htmlFor="lastName">Last Name</label>
                <div>
                  <input
                    id="lastName"
                    type="text"
                    ref="lastName"
                    className="form-control"
                    required
                  />
                </div>
                {!!lastNameError && (<div className="help-block">{lastNameError.message}</div>)}
                <div className="help-block">Enter the individual's last name.</div>
              </div>

              <div className={cx('form-group', {
                'has-error': !!emailError
              })}>
                <label className="control-label required" htmlFor="email">Email Address</label>
                <div>
                  <input
                    id="email"
                    type="text"
                    ref="email"
                    className="form-control"
                    required
                  />
                </div>
                {!!emailError && (<div className="help-block">{emailError.message}</div>)}
                <div className="help-block">The email address used by this individual.</div>
              </div>

              <div className={cx('form-group', {
                'has-error': !!contactNumberError
              })}>
                <label className="control-label required" htmlFor="contactNumber">Contact Phone Number</label>
                <div>
                  <input
                    id="contactNumber"
                    type="text"
                    ref="contactNumber"
                    className="form-control"
                    required
                  />
                </div>
                {!!contactNumberError && (<div className="help-block">{contactNumberError}</div>)}
                <div className="help-block">A day time contact phone number for this individual.</div>
              </div>

              <AccessSelector ref="roleSelector" className={roleError && 'has-error'} showPartner={this.state.client && !!this.state.client.partner}>
                {roleError && (
                  <div className="help-block">{roleError.message}</div>
                )}
                <div className="help-block">Choose the access level that this individual will be granted.</div>
              </AccessSelector>

            </div>
            <div className="modal-footer">
              <ButtonLink to="access">Close</ButtonLink>
              <Button to="access" bsStyle="success" type="submit">
                {this.state.working === 'AUTH' && (
                  <span><i className="fa fa-spinner fa-spin"></i> </span>
                )}
                Authorise
              </Button>
            </div>
          </form>
        </Modal>
      </div>
    );
  }
})
module.exports = AccessNew;



// WEBPACK FOOTER //
// ./app/components/Access/AccessNew.js